<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Move to another agent</h2>
        </template>
        <template v-slot:body>
            <div class="form-group">
                <select
                    class="form-control"
                    :class="{'has-error': errors.first('user_uuid') }"
                    name="user_uuid"
                    v-model="formData.user_uuid"
                    v-validate.persist="'required'"
                    data-vv-as="agent"
                >
                    <option value="" selected disabled>Please select an agent</option>
                    <option :value="user.uuid">&rarr; My Company</option>
                    <option
                        v-for="agent in filteredUserAgents"
                        :key="agent.uuid"
                        :value="agent.uuid"
                    >
                        {{ agent.fullname }}
                    </option>
                </select>
                <div class="form-error">{{ errors.first('user_uuid') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    :disabled="isLoading"
                    @click.prevent="onMove"
                >
                    Move
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        ad: {
            type: Object,
            required: true,
        },
        agents: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            formData: {
                slug: this.ad.slug,
                user_uuid: '',
            },
        };
    },
    updated() {
        if (this.showModal) {
            this.isLoading = false;
            this.formData = {
                slug: this.ad.slug,
                user_uuid: '',
            };
            this.filterUserAgents({ active: 'active' });
        }
        this.$validator.reset();
    },
    computed: {
        ...mapState('user', ['user', 'filteredUserAgents']),
    },
    methods: {
        ...mapActions('user', [
            'filterUserAgents',
        ]),
        onMove() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.$emit('move', this.formData);
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
